module.exports = __webpack_public_path__ + "img/morefilters.1ed9d6f1.svg";